// extracted by mini-css-extract-plugin
export default {"title":"SeventhScreen_title__YfQ9X"};